// Cyber Punk Hero Slideshow JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.cyber-hero__slider');
  
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.cyber-hero__slide');
    const dotsContainer = slider.parentElement.querySelector('.cyber-hero__dots');
    const prevBtn = slider.parentElement.querySelector('.cyber-hero__arrow--prev');
    const nextBtn = slider.parentElement.querySelector('.cyber-hero__arrow--next');
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = parseInt(slider.dataset.interval) || 5000;
    
    let currentSlide = 0;
    let autoplayTimer;
    
    // Create dots
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('cyber-hero__dot');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.setAttribute('role', 'tab');
      if (index === 0) dot.classList.add('active');
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });
    
    const dots = dotsContainer.querySelectorAll('.cyber-hero__dot');
    
    function goToSlide(n) {
      slides[currentSlide].classList.remove('active');
      dots[currentSlide].classList.remove('active');
      
      currentSlide = (n + slides.length) % slides.length;
      
      slides[currentSlide].classList.add('active');
      dots[currentSlide].classList.add('active');
      
      if (autoplay) {
        clearInterval(autoplayTimer);
        startAutoplay();
      }
    }
    
    function nextSlide() {
      goToSlide(currentSlide + 1);
    }
    
    function prevSlide() {
      goToSlide(currentSlide - 1);
    }
    
    function startAutoplay() {
      autoplayTimer = setInterval(nextSlide, interval);
    }
    
    // Initialize first slide
    slides[0].classList.add('active');
    
    // Event listeners
    nextBtn.addEventListener('click', nextSlide);
    prevBtn.addEventListener('click', prevSlide);
    
    // Start autoplay if enabled
    if (autoplay) {
      startAutoplay();
    }
    
    // Pause on hover
    slider.parentElement.addEventListener('mouseenter', () => {
      if (autoplay) clearInterval(autoplayTimer);
    });
    
    slider.parentElement.addEventListener('mouseleave', () => {
      if (autoplay) startAutoplay();
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cyber-hero__slider').forEach(slider => {
    const slides = slider.querySelectorAll('.cyber-hero__slide');
    const dotsWrap = slider.parentElement.querySelector('.cyber-hero__dots');
    const prev = slider.parentElement.querySelector('.cyber-hero__arrow--prev');
    const next = slider.parentElement.querySelector('.cyber-hero__arrow--next');
    const auto = slider.dataset.autoplay === 'true';
    const ms = parseInt(slider.dataset.interval) || 5000;
    
    let idx = 0, timer;
    
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.setAttribute('aria-label', `Slide ${i+1}`);
      if (i === 0) dot.classList.add('active');
      dot.onclick = () => go(i);
      dotsWrap.appendChild(dot);
    });
    
    const dots = [...dotsWrap.children];
    
    function go(n) {
      slides[idx].classList.remove('is-active');
      dots[idx].classList.remove('active');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active');
      dots[idx].classList.add('active');
      if (auto) { clearInterval(timer); timer = setInterval(() => go(idx+1), ms); }
    }
    
    slides[0].classList.add('is-active');
    prev.onclick = () => go(idx - 1);
    next.onclick = () => go(idx + 1);
    if (auto) timer = setInterval(() => go(idx+1), ms);
  });
});
